import { getTheme, Stack, Icon, Text } from "@fluentui/react";

import { AccountSignatureContact } from "./interfaces";

import { AccountContactType } from "@/components/Contracts/ConfirmationStep/Signature/signature.interface";
import { phoneNumberFormatter } from "@/utils/PhoneNumberFormatter";

interface RenderFixedContactOptionsProps {
  contactType: AccountContactType;
  contacts: AccountSignatureContact[];
}

export function RenderFixedContactOptions({
  contactType,
  contacts
}: RenderFixedContactOptionsProps) {
  const theme = getTheme();
  const isWhatsApp = contactType === AccountContactType.WHATSAPP;
  const getContactIcon = (isWhatsApp: boolean) => {
    return isWhatsApp ? "CellPhone" : "Mail";
  };

  return (
    <Stack
      tokens={{ childrenGap: 12 }}
      styles={{ root: { width: "100%", maxWidth: "500px" } }}
    >
      <Text
        variant="medium"
        styles={{ root: { fontWeight: 600, textAlign: "center" } }}
      >
        A assinatura será enviada para:
      </Text>

      <Stack tokens={{ childrenGap: 8 }}>
        {contacts.map((contact, index) => (
          <Stack.Item key={index}>
            <Stack
              horizontal
              verticalAlign="center"
              tokens={{ childrenGap: 12 }}
              styles={{
                root: {
                  padding: "16px",
                  backgroundColor: theme.palette.white,
                  borderRadius: "4px",
                  border: `1px solid ${theme.palette.neutralQuaternaryAlt}`,
                  boxShadow: theme.effects.elevation4
                }
              }}
            >
              <Icon
                iconName={getContactIcon(isWhatsApp)}
                styles={{
                  root: {
                    fontSize: "16px",
                    color: theme.palette.themePrimary
                  }
                }}
              />

              <Stack tokens={{ childrenGap: 4 }} styles={{ root: { flex: 1 } }}>
                <Text
                  variant="mediumPlus"
                  styles={{
                    root: {
                      fontWeight: 600,
                      color: theme.palette.neutralPrimary
                    }
                  }}
                >
                  {contact.fullName}
                </Text>

                <Text
                  variant="medium"
                  styles={{
                    root: {
                      color: theme.palette.neutralSecondary
                    }
                  }}
                >
                  {isWhatsApp
                    ? phoneNumberFormatter(contact.contact)
                    : contact.contact}
                </Text>
              </Stack>
            </Stack>
          </Stack.Item>
        ))}
      </Stack>
    </Stack>
  );
}
